module.exports = __webpack_public_path__ + "static/media/discord.bb408e03.svg";